// extracted by mini-css-extract-plugin
export default {"version-title-with-status":"uCb6s3"};